import styled from 'styled-components'
import ModalLayout from './ModalLayout'
import Text from '../../atoms/Text'
import MainButton from '../../atoms/MainButton'

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
  gap: 8px;
`
const ButtonWrapper = styled.div`
  display: flex;
  margin-top: 20px;
  gap: 8px;
 `

const ExitModal = ({ title, onClose, onConfirm }) => {
  return (
    <ModalLayout>
      <>
        <TextWrapper>
          <Text variant="headline3" weight="bold">{title}</Text>
          <Text>지금까지 입력한 내용이 모두 사라져요.</Text>
        </TextWrapper>
        <ButtonWrapper>
          <MainButton
            $variant="cancel"
            $size="small"
            title="취소"
            onClick={onClose}/>
          <MainButton
            $variant="destructive"
            $size="small"
            title="나가기"
            onClick={onConfirm}/>
        </ButtonWrapper>
      </>
    </ModalLayout>
  )
}

export default ExitModal
